import React from 'react';
import MetricCard from '@/components/ui/MetricCard';
import {
  PoundSterling,
  Receipt,
  ShieldCheck,
  Landmark,
  Clock,
  Star,
} from 'lucide-react';

// Grid plan: 6 cards → grid-cols-4 2xl:grid-cols-4
// Row 1: hero (spans 2 cols) + 2 regular
// Row 2: 3 regular cards

export default function KPIBentoGrid() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 gap-4">
      {/* Hero: Gross Pay — spans 2 cols */}
      <MetricCard
        label="Gross Pay — This Period"
        value="£38,472"
        subValue="47 workers · Week 18 · TY 2025/26"
        trend="up"
        trendValue="+3.2%"
        trendLabel="vs last week"
        icon={<PoundSterling size={16} />}
        className="sm:col-span-2 lg:col-span-2"
      />

      {/* PAYE Tax */}
      <MetricCard
        label="PAYE Tax Deducted"
        value="£7,340"
        subValue="Avg. £156.17 / worker"
        trend="neutral"
        trendValue="±0.4%"
        trendLabel="vs last week"
        icon={<Receipt size={16} />}
      />

      {/* NI Contributions */}
      <MetricCard
        label="NI Contributions"
        value="£5,218"
        subValue="Ee: £2,891 · Er: £2,327"
        trend="up"
        trendValue="+1.8%"
        trendLabel="vs last week"
        icon={<ShieldCheck size={16} />}
      />

      {/* Pension */}
      <MetricCard
        label="Pension (Auto-Enrolment)"
        value="£1,154"
        subValue="NEST · 5% Ee + 3% Er"
        trend="up"
        trendValue="+3.2%"
        trendLabel="matches gross"
        icon={<Landmark size={16} />}
        variant="success"
      />

      {/* Timesheets Pending — alert */}
      <MetricCard
        label="Timesheets Pending"
        value="4"
        subValue="Must approve before RTI"
        variant="alert"
        icon={<Clock size={16} />}
      />

      {/* CQC Rating */}
      <MetricCard
        label="CQC Rating — Last Inspection"
        value="Good"
        subValue="Inspected 14 months ago · Inspection window open"
        trend="neutral"
        trendValue="Next window: Jun–Aug 2026"
        icon={<Star size={16} />}
        variant="success"
        className="sm:col-span-2 lg:col-span-2"
      />
    </div>
  );
}